// @flow strict
import * as React from 'react';

import { ChoiceGroup, Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import {
  selectAllResults,
  selectFilteredList,
  selectProvidedList,
} from '../../DomainCreate/modules/selectors/results';

import type { ExtendedSuggestion } from '../../DomainCreate/types';

import { DomainRow } from './DomainRow';

export type Props = {
  selectedDomain: string | void,
  setDomain: (value: ExtendedSuggestion | void) => mixed,
  provided?: boolean,
};

export function DomainList({
  provided,
  selectedDomain,
  setDomain,
}: Props): React.MixedElement | null {
  const suggestions = useAppSelector(state =>
    provided
      ? selectProvidedList(state, 'popularity')
      : selectFilteredList(state, 'popularity'),
  );

  const results = useAppSelector(selectAllResults);

  const renderSuggestionRow = (
    // eslint-disable-next-line no-shadow
    suggestions: Array<string>,
    // eslint-disable-next-line no-shadow
    provided: ?boolean,
    // eslint-disable-next-line no-shadow
    selectedDomain: ?string,
  ) => {
    if (provided) {
      return suggestions.map(s => {
        return (
          <DomainRow selectedDomain={selectedDomain} suggestion={s} provided />
        );
      });
    }

    return (
      <Base gap="xsmall" grid>
        {suggestions.map(s => {
          return (
            <DomainRow
              selectedDomain={selectedDomain}
              suggestion={s}
              provided={false}
            />
          );
        })}
      </Base>
    );
  };

  return !suggestions.length ? null : (
    <ChoiceGroup
      legend="domain-choices"
      value={selectedDomain}
      onValueChange={(fqdn: string) => {
        setDomain(results.find(r => r.fqdn === fqdn));
      }}
    >
      {renderSuggestionRow(suggestions, provided, selectedDomain)}
    </ChoiceGroup>
  );
}
